import { render, staticRenderFns } from "./UploadRekomendasi.vue?vue&type=template&id=b8a1b466"
import script from "./UploadRekomendasi.vue?vue&type=script&lang=js"
export * from "./UploadRekomendasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports